import { combineReducers } from 'redux';
import { genericReducer } from './Generic/GenericReducer';
import { GenericState } from './Generic/GenericState';
import { walkieTalkieReducer } from './WalkieTalkie/WalkieTalkieReducer';
import { WalkieTalkieState } from './WalkieTalkie/WalkieTalkieState';

const rootReducer = combineReducers({
    generic: genericReducer,
    walkieTalkie: walkieTalkieReducer
});

export interface GlobalState {
    generic: GenericState;
    walkieTalkie: WalkieTalkieState;
}

export default rootReducer;
